import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import focalPointApiClient from 'Services/Apis/FocalPoint/conciergeApiClient';

export const getListHistoryThunk = createAsyncThunk(
    `GetListHistorySlicer/getListHistoryThunk`,
    async ({ distributionNumber, distributionChannel, solicitationDate, orderBy, page }, { getState }) => {
        const { user } = getState().oidc;

        const headers = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
        };

        var url = `/DistributionAvailableAndHistory/get-paginated?&size=${10}`;

        if (distributionNumber != "") {
            url += `&distributionNumber=${distributionNumber}`;
        }

        if (distributionChannel != "") {
            url += `&distributionChannel=${distributionChannel}`;
        }

        if (solicitationDate != undefined) {
            url += `&solicitationDate=${solicitationDate}`;
        }

        if (orderBy != undefined) {
            url += `&orderBy=${orderBy}`;
        }

        if (page != undefined) {
            url += `&page=${page}`;
        }

        const { data } = await focalPointApiClient.get(
            url,
            {
                headers,
            });
        return data;
    }
);

const initialState = {
    dataGetListHistory: [],
    loadingGetListHistory: false,
    errorGetListHistory: false,
};

const GetListHistorySlicer = createSlice({
    name: 'GetListHistory',
    initialState,
    reducers: {
        resetDataGetListHistory: (state) => {
            state.dataGetListHistory = [];
            state.loadingGetListHistory = false;
            state.errorGetListHistory = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getListHistoryThunk.pending, (state) => {
            state.dataGetListHistory = [];
            state.loadingGetListHistory = true;
            state.errorGetListHistory = false;
        });
        builder.addCase(getListHistoryThunk.fulfilled, (state, action) => {
            state.dataGetListHistory = action.payload;
            state.loadingGetListHistory = false;
            state.errorGetListHistory = false;
        });
        builder.addCase(getListHistoryThunk.rejected, (state) => {
            state.dataGetListHistory = [];
            state.loadingGetListHistory = false;
            state.errorGetListHistory = true;
        });
    },
});

export const { resetDataGetListHistory } = GetListHistorySlicer.actions;
export default GetListHistorySlicer.reducer;